/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, OnInit } from '@angular/core';
import { AccountService } from '../../services/account.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';
import { ErrorService } from '../../services/error.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'change-password',
  templateUrl: './change-password.component.html',
  standalone: false,
})
export class ChangePasswordComponent implements OnInit {
  passwordChangeObj: PasswordChangeObject;
  confirmPassword: string;
  error: string;

  constructor(
    private accountService: AccountService,
    public activeModal: NgbActiveModal,
    private errorService: ErrorService,
  ) {}

  ngOnInit(): void {
    this.passwordChangeObj = { currentPassword: '', newPassword: '' };
  }

  async changePassword(f: NgForm) {
    this.error = '';
    try {
      await this.accountService.changePassword(this.passwordChangeObj);
      this.activeModal.close();
    } catch (error) {
      try {
        if ((error as HttpErrorResponse).error !== undefined) {
          const obj = JSON.parse((error as HttpErrorResponse).error);
          if (obj.message === 'Current password invalid') {
            this.error = 'SDE_PASSWORD_INCORRECT';
          } else if (
            obj.message ===
            'The password you entered has been found in a data breach. Please choose a different password.'
          ) {
            this.error = 'SDE_PASSWORD_ENTERED_FOUND';
          } else {
            this.error = 'SDE_OPERATION_FAILED_PLEASE2';
          }
          f.form.get('currentPassword')?.setErrors({ customerror: true });
        }
      } catch (error) {
        this.errorService.displayGeneralError().result.then(() => {
          this.activeModal.dismiss();
        });
      }
    }
  }
}

export interface PasswordChangeObject {
  currentPassword: string;
  newPassword: string;
}
